import { render, staticRenderFns } from "./ClassroomSubmissionDetail.vue?vue&type=template&id=c078f66c&scoped=true"
import script from "./ClassroomSubmissionDetail.vue?vue&type=script&lang=js"
export * from "./ClassroomSubmissionDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassroomSubmissionDetail.vue?vue&type=style&index=0&id=c078f66c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078f66c",
  null
  
)

export default component.exports